<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack" v-if="hasBack==='true'">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:100%;">
        <span v-if="recordInfo.ALERT_TYPE === 'F'" style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          设备
          <span v-if="companyInfo.COMPANY_NAME">- {{companyInfo.COMPANY_NAME}}</span>
        </span>
        <span v-else-if="recordInfo.ALERT_TYPE === 'T'" style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          设备告警
          <span v-if="companyInfo.COMPANY_NAME">- {{companyInfo.COMPANY_NAME}}</span>
        </span>
        <span v-else style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          设备消息
          <span v-if="companyInfo.COMPANY_NAME">- {{companyInfo.COMPANY_NAME}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0.9rem 1.1rem 5rem;color:rgba(33, 33, 33, 0.9);">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <AlertDetailF v-if="recordInfo.ALERT_TYPE === 'F'" :deviceInfo="deviceInfo" :alertInfo="alertInfo" :recordInfo="recordInfo" :activated="activated"/>
          <AlertDetailT v-else-if="recordInfo.ALERT_TYPE === 'T'" :deviceInfo="deviceInfo" :alertInfo="alertInfo" :recordInfo="recordInfo" :activated="activated"/>
          <AlertDetailMsg v-else :deviceInfo="deviceInfo" :alertInfo="alertInfo" :recordInfo="recordInfo" :activated="activated"/>
            <!-- <div>
                <v-row>
                    <v-col :cols="3" style="color:#9e9e9e;">设备名称</v-col>
                    <v-col :cols="9" v-if="activated">
                        <span>{{deviceInfo.DEV_TEXT}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" style="color:#9e9e9e;">故障描述</v-col>
                    <v-col :cols="9" v-if="activated" style="font-size: 1.1rem;">
                        <span v-if="recordInfo.ALERT_TYPE === 'F'" style="color:#67C23A;">{{alertInfo.text}}</span>
                        <span v-else style="color:#F56C6C;">{{alertInfo.text}}</span>
                    </v-col>
                </v-row>
                <v-row v-if="activated && alertInfo.value">
                    <v-col :cols="3" style="color:#9e9e9e;">警报值</v-col>
                    <v-col :cols="9">
                        <span>{{alertInfo.value}}{{alertInfo.unit ? alertInfo.unit : ''}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" style="color:#9e9e9e;">告警开始时间</v-col>
                    <v-col :cols="9" v-if="activated">
                        <span>{{$moment(alertInfo.alarm_begin_time).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    </v-col>
                </v-row>
                 <v-row v-if="recordInfo.ALERT_TYPE === 'F'">
                    <v-col :cols="3" style="color:#9e9e9e;">告警结束时间</v-col>
                    <v-col :cols="9" v-if="activated">
                        <span>{{$moment(recordInfo.ROW_DATE_CREATE).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" style="color:#9e9e9e;">告警持续时间</v-col>
                    <v-col :cols="9" v-if="activated">
                        <span>{{getTimeStr(alertInfo.alarm_span_time_s)}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col :cols="3" style="color:#9e9e9e;">备注</v-col>
                    <v-col :cols="9" v-if="activated">
                        <span v-if="!(alertInfo.code === '200' || alertInfo.code === 200)">请相关工作人员及时处理!</span>
                        <span v-else>设备恢复正常.</span>
                    </v-col>
                </v-row>
            </div> -->
            <!-- <div style="margin-top:2rem;" v-if="alertInfo.ALERT_TYPE === 'T'">
                <div v-if="alertOrder.BIZ_SID === 2" style="text-align:center;color:#67C23A;">
                  <span v-if="pro_user" style="margin-right:0.2rem;">{{pro_user.name}} 已经处理完成.</span>
                  <span v-else>已经恢复正常.</span>
                </div>
                <div v-else>
                  <div v-if="alertOrder.PROCESS_SID === 0">
                      <v-row>
                          <v-col :cols="4" style="color:#9e9e9e;">选择处理用时</v-col>
                          <v-col :cols="7" style="position: relative;">
                              <select id="us-select" style="width:100%;outline:none;" v-model="selectVal"  >
                                  <option :value="item.value" v-for="(item,index) in list" :key="index">{{item.label}}</option>
                              </select>
                              <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;position:absolute;right:5rem;pointer-events:none;" ></i>
                          </v-col>
                      </v-row>
                      <div style="text-align:center;margin-top:1rem;">
                          <v-btn color="primary" style="width:50%;" @click="processAlert">我来处理</v-btn>
                      </div>
                  </div>
                  <div v-else style="text-align:center;color:#FB8C00;font-size:0.9rem;margin-top: 2rem;">
                    <span style="margin-right:0.2rem;" v-if="pro_user">{{pro_user.name}}</span>
                    <span>正在处理.</span>
                  </div>
                </div>
            </div>
            <div v-else style="margin-top:2rem;text-align:center;color:#67C23A;">
              <span v-if="pro_user" style="margin-right:0.2rem;">{{pro_user.name}} 已经处理完成.</span>
            </div> -->
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import AlertDetailF from './components/AlertDetailF'
import AlertDetailT from './components/AlertDetailT'
import AlertDetailMsg from './components/AlertDetailMsg'
export default {
  components: { LoadingText, AlertDetailF, AlertDetailT, AlertDetailMsg },
  props: {
  },
  data() {
    return {
      iotId: '',
      propInfo: {},
      deviceInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: true,
      loading: true,
      alertCode: 0,
      alertInfo: {},
      recordInfo: {},
      list: [
        { label: '15分钟', value: 15 },
        { label: '30分钟', value: 30 },
        { label: '1小时', value: 60 },
        { label: '2小时', value: 120 },
        { label: '3小时', value: 180 },
        { label: '4小时', value: 240 },
        { label: '5小时', value: 300 }
      ],
      selectVal: 15,
      alertOrder: {},
      pro_user: {},
      hasBack: false
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.alertCode = that.$route.params.code ? that.$route.params.code : ''
    that.hasBack = that.$route.query.has_back ? that.$route.query.has_back : false
    await that.getDeviceAlert()
    await that.getDevice()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.warning('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.deviceInfo = data.device
        that.companyInfo = data.company
        that.activated = that.deviceInfo.CUR_SID !== '0'
      })
    },
    async getDeviceAlert() {
      var that = this
      await that.$api.bz.getDeviceAlert({ code: that.alertCode }).then(res => {
        console.log('getDeviceAlert.res', res);
        if (!res.success) {
          // that.$toast.error('获取设备信息失败')
          console.log('获取设备警报信息失败', res);
          return
        }
        var data = res.data
        that.iotId = data.record.DEVICE_IOT_ID
        that.recordInfo = data.record
        that.alertOrder = data.alert
        that.pro_user = data.pro_user
        if (data.record.EVT_PARAMS) {
          try {
            that.alertInfo = JSON.parse(data.record.EVT_PARAMS)
            if (that.alertInfo.value) {
              that.alertInfo.value = that.alertInfo.value.toFixed()
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    // 时间格式化
    getTimeStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    },
    async processAlert() {
      var that = this
      var res = await that.$api.bz.processDeviceAlert({ code: that.alertOrder.ALERT_ORDER_CODE, dura: that.selectVal });
      // console.log('processDeviceAlert.res', res);
      if (!res.success) {
        that.$toast.warning('操作失败')
        return;
      }
      await that.getDeviceAlert();
      that.$toast.success('操作成功')
    }
  }
}
</script>

<style scoped>
.ss{
  position: relative;
}
</style>
